$.extend(true, BT, {
  selectors: {
    recentViewWrap: '.recent-view',
    recentViewTitle: '.rv__title',
    recentViewWrapContent: '.rv__wrap-content',
    recentViewList: '.rv__content',
    recentViewNumber: '.rv-number',
    recentTrigger: '.rv-trigger',
  },

	loadRecentViewProducts: function() {
    const wrap = $(this.selectors.recentViewWrap);
    if(wrap.length > 0) {
      const list = $(this.selectors.recentViewList);
      const idItems = this.getCookieItemsValue(true, this.options.recentView.cookieName);
      if(idItems.length > 0) {
        idItems.reverse();
        var ids = idItems.slice(0, 3);
        this.callAjax(theme.searchUrl, 'GET', {view:'recent_view_list', q: this.getQueryByIds(ids), type: 'product'}, null, (html) => {
          list.html('');
          $.each(ids, (index, id) => {
            list.append($('#recent-item-' + id, html).html());
          });
          if(list.find('.item').length > 0) {
            this.convertCurrencySilence(list.find('span.money'));
            $(this.selectors.recentViewNumber).text(list.find('.item').length);
          }
        });
      } else {
        list.append('<div class="alert alert-warning w100" style="margin-top:20px;margin-left:15px;margin-right:15px;">' + theme.strings.recentViewEmpty + '</div>');
      }
    }
  },

  initRecentlyViewed: function() {
    const wrap = $(this.selectors.recentViewWrap), openClass = "open", workingClass = "working";
    this.loadRecentViewProducts();
    $(document).on('click', this.selectors.recentTrigger, (e) => {
      e.preventDefault();
      wrap.toggleClass(openClass);
    });
  }
});
BT.initRecentlyViewed();